import { render, staticRenderFns } from "./InlineCurrencyField.vue?vue&type=template&id=501b4108&"
import script from "./InlineCurrencyField.vue?vue&type=script&lang=js&"
export * from "./InlineCurrencyField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports